import Vue from 'vue'
import Router from 'vue-router'
import Main from './components/Main.vue'
import CreateProject from './components/CreateProject.vue'
import ManageProjects from './components/ManageProjects.vue'
import EditProject from './components/EditProject.vue'
import JoinProject from './components/JoinProject.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/create',
      name: 'create',
      component: CreateProject
    },
    {
      path: '/manage',
      name: 'manage',
      component: ManageProjects
    },
    {
      path: '/project/:id',
      name: 'project',
      component: EditProject,
    },
    {
      path: '/project/:id/join',
      name: 'join-project',
      component: JoinProject,
    },
    {
      path: '/',
      name: 'home',
      component: Main
    },

  ]
})
